"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.occur = void 0;
const Actions = __importStar(require("../actions"));
const closure_1 = require("../closure");
const ctx_1 = require("../ctx");
const Neutrals = __importStar(require("../neutral"));
const solution_1 = require("../solution");
const freshen_1 = require("../utils/freshen");
const Values = __importStar(require("../value"));
function occurType(mod, ctx, name, value) {
    return occur(mod, ctx, name, Values.Type(), value);
}
function occur(mod, ctx, name, type, value) {
    switch (value["@kind"]) {
        case "TypedNeutral": {
            return occurNeutral(mod, ctx, name, value.neutral);
        }
        case "Type": {
            return false;
        }
        case "Pi": {
            if (occurType(mod, ctx, name, value.argType))
                return true;
            const boundName = value.retTypeClosure.name;
            const usedNames = [...(0, ctx_1.ctxNames)(ctx), ...(0, solution_1.solutionNames)(mod.solution), name];
            const freshName = (0, freshen_1.freshen)(usedNames, boundName);
            const v = Values.TypedNeutral(value.argType, Neutrals.Var(freshName));
            const retType = (0, closure_1.closureApply)(value.retTypeClosure, v);
            return occurType(mod, ctx, name, retType);
        }
        case "PiImplicit": {
            if (occurType(mod, ctx, name, value.argType))
                return true;
            const boundName = value.retTypeClosure.name;
            const usedNames = [...(0, ctx_1.ctxNames)(ctx), ...(0, solution_1.solutionNames)(mod.solution), name];
            const freshName = (0, freshen_1.freshen)(usedNames, boundName);
            const v = Values.TypedNeutral(value.argType, Neutrals.Var(freshName));
            const retType = (0, closure_1.closureApply)(value.retTypeClosure, v);
            return occurType(mod, ctx, name, retType);
        }
        case "Fn": {
            Values.assertTypeInCtx(mod, ctx, type, "Pi");
            const boundName = value.retClosure.name;
            const usedNames = [...(0, ctx_1.ctxNames)(ctx), ...(0, solution_1.solutionNames)(mod.solution), name];
            const freshName = (0, freshen_1.freshen)(usedNames, boundName);
            const v = Values.TypedNeutral(type.argType, Neutrals.Var(freshName));
            const retType = (0, closure_1.closureApply)(type.retTypeClosure, v);
            const ret = (0, closure_1.closureApply)(value.retClosure, v);
            return occur(mod, ctx, name, retType, ret);
        }
        case "FnImplicit": {
            Values.assertTypeInCtx(mod, ctx, type, "PiImplicit");
            const boundName = value.retClosure.name;
            const usedNames = [...(0, ctx_1.ctxNames)(ctx), ...(0, solution_1.solutionNames)(mod.solution), name];
            const freshName = (0, freshen_1.freshen)(usedNames, boundName);
            const v = Values.TypedNeutral(type.argType, Neutrals.Var(freshName));
            const retType = (0, closure_1.closureApply)(type.retTypeClosure, v);
            const ret = (0, closure_1.closureApply)(value.retClosure, v);
            return occur(mod, ctx, name, retType, ret);
        }
        case "Sigma": {
            if (occurType(mod, ctx, name, value.carType))
                return true;
            const boundName = value.cdrTypeClosure.name;
            const usedNames = [...(0, ctx_1.ctxNames)(ctx), ...(0, solution_1.solutionNames)(mod.solution), name];
            const freshName = (0, freshen_1.freshen)(usedNames, boundName);
            const v = Values.TypedNeutral(value.carType, Neutrals.Var(freshName));
            const cdrType = (0, closure_1.closureApply)(value.cdrTypeClosure, v);
            return occurType(mod, ctx, name, cdrType);
        }
        case "Cons": {
            Values.assertTypeInCtx(mod, ctx, type, "Sigma");
            if (occur(mod, ctx, name, type.carType, value.car))
                return true;
            const cdrType = (0, closure_1.closureApply)(type.cdrTypeClosure, value.car);
            return occur(mod, ctx, name, cdrType, value.cdr);
        }
        case "String": {
            return false;
        }
        case "Quote": {
            return false;
        }
        case "Trivial": {
            return false;
        }
        case "Sole": {
            return false;
        }
        case "ClazzNull": {
            return false;
        }
        case "ClazzCons": {
            if (occurType(mod, ctx, name, value.propertyType))
                return true;
            const boundName = value.restClosure.name;
            const usedNames = [...(0, ctx_1.ctxNames)(ctx), ...(0, solution_1.solutionNames)(mod.solution), name];
            const freshName = (0, freshen_1.freshen)(usedNames, boundName);
            const v = Values.TypedNeutral(value.propertyType, Neutrals.Var(freshName));
            const rest = (0, closure_1.closureApply)(value.restClosure, v);
            return occurType(mod, ctx, name, rest);
        }
        case "ClazzFulfilled": {
            return (occurType(mod, ctx, name, value.propertyType) ||
                occur(mod, ctx, name, value.propertyType, value.property) ||
                occurType(mod, ctx, name, value.rest));
        }
        case "Objekt": {
            Values.assertClazzInCtx(mod, ctx, type);
            return occurProperties(mod, ctx, name, type, value);
        }
        case "Equal": {
            return (occurType(mod, ctx, name, value.type) ||
                occur(mod, ctx, name, value.type, value.from) ||
                occur(mod, ctx, name, value.type, value.to));
        }
        case "Refl": {
            return (occurType(mod, ctx, name, value.type) ||
                occur(mod, ctx, name, value.type, value.value));
        }
    }
}
exports.occur = occur;
function occurProperties(mod, ctx, name, clazz, value) {
    switch (clazz["@kind"]) {
        case "ClazzNull": {
            return false;
        }
        case "ClazzCons": {
            const propertyValue = Actions.doDot(value, clazz.propertyName);
            const rest = Values.clazzClosureApply(clazz.restClosure, propertyValue);
            return (occur(mod, ctx, name, clazz.propertyType, propertyValue) ||
                occurProperties(mod, ctx, name, rest, value));
        }
        case "ClazzFulfilled": {
            const propertyValue = Actions.doDot(value, clazz.propertyName);
            return (occur(mod, ctx, name, clazz.propertyType, propertyValue) ||
                occurProperties(mod, ctx, name, clazz.rest, value));
        }
    }
}
function occurTypedValue(mod, ctx, name, typedValue) {
    return (occurType(mod, ctx, name, typedValue.type) ||
        occur(mod, ctx, name, typedValue.type, typedValue.value));
}
function occurNeutral(mod, ctx, name, neutral) {
    switch (neutral["@kind"]) {
        case "Var": {
            // return name === neutral.name
            return false;
        }
        case "PatternVar": {
            return name === neutral.name;
        }
        case "Ap": {
            return (occurNeutral(mod, ctx, name, neutral.target) ||
                occurTypedValue(mod, ctx, name, neutral.arg));
        }
        case "ApImplicit": {
            return (occurNeutral(mod, ctx, name, neutral.target) ||
                occurTypedValue(mod, ctx, name, neutral.arg));
        }
        case "Car":
        case "Cdr": {
            return occurNeutral(mod, ctx, name, neutral.target);
        }
        case "Dot": {
            return occurNeutral(mod, ctx, name, neutral.target);
        }
        case "Replace": {
            return (occurNeutral(mod, ctx, name, neutral.target) ||
                occurTypedValue(mod, ctx, name, neutral.motive) ||
                occurTypedValue(mod, ctx, name, neutral.base));
        }
    }
}
//# sourceMappingURL=occur.js.map